<script setup>
import { NOTIFICATION_TYPES } from '@/constants/messages';
import { computed } from 'vue';
import IconError from '~icons/svg/error';
import IconCheck from '~icons/svg/check';
import IconInfo from '~icons/svg/info';
const props = defineProps({
  show: Boolean,
  type: {
    type: String,
    default: NOTIFICATION_TYPES.ERROR, // 'error' | 'success' | 'info'
  },
});

// typeから表示すべきアイコンを決定するマッピング
const iconComponent = computed(() => {
  switch (props.type) {
    case NOTIFICATION_TYPES.SUCCESS:
      return IconCheck;
    case NOTIFICATION_TYPES.ERROR:
      return IconError;
    default:
      return IconInfo;
  }
});
</script>

<template>
  <transition
    enter-active-class="transform ease-out duration-300 transition"
    enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
    enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
    leave-active-class="transition ease-in duration-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div v-if="show" class="fixed bottom-32 right-5 z-50">
      <div
        class="text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-2"
        :class="type === NOTIFICATION_TYPES.ERROR ? 'bg-red-500' : 'bg-emerald-500'"
      >
        <component :is="iconComponent" />
        <span class="font-bold">
          <slot />
        </span>
      </div>
    </div>
  </transition>
</template>
